import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <div className="flex items-center gap-3 mb-5">
    <span className="h-px w-10 bg-teal" />
    <span className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-teal">
      {children}
    </span>
  </div>
);

export default Reveal;
